import { AnalysisResult, HealthCheckResponse } from '../types/analysis';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://aifraudapi.onrender.com';

class ApiService {
  private async request<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<T> {
    const url = `${API_BASE_URL}/v1${endpoint}`;
    
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async analyzeImage(imageFile: File): Promise<AnalysisResult> {
    console.log("Frontend: Starting image analysis for file:", imageFile.name);
    console.log("Frontend: API URL:", `${API_BASE_URL}/v1/analyze`);
    
    const formData = new FormData();
    formData.append('image', imageFile);

    console.log("Frontend: Sending request...");
    const response = await fetch(`${API_BASE_URL}/v1/analyze`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${process.env.REACT_APP_API_KEY || 'test-key-123'}`,
      },
      body: formData,
    });

    console.log("Frontend: Response status:", response.status);
    console.log("Frontend: Response ok:", response.ok);

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      console.error("Frontend: Error response:", error);
      throw new Error(error.message || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log("Frontend: Analysis result:", result);
    return result;
  }

  async healthCheck(): Promise<HealthCheckResponse> {
    return this.request<HealthCheckResponse>('/health');
  }
}

export const apiService = new ApiService();
